module.exports = __webpack_public_path__ + "static/zama_licor_1-6d2953eff7468075a7c213565d788593.jpg";